const TikTokLogo = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="37" viewBox="0 0 32 37" fill="none">
            <path d="M18.2143 0.500023L22.5999 0.5C22.9165 2.10877 23.7956 4.13838 25.3333 6.15187C26.84 8.12479 28.8365 9.50002 31.5 9.50002V14C27.6175 14 24.7001 12.1695 22.6429 9.88563V25.25C22.6429 31.4632 17.686 36.5 11.5714 36.5C5.45685 36.5 0.5 31.4632 0.5 25.25C0.5 19.0368 5.45685 14 11.5714 14V18.5C7.90268 18.5 4.92857 21.5221 4.92857 25.25C4.92857 28.9779 7.90268 32 11.5714 32C15.2402 32 18.2143 28.9779 18.2143 25.25V0.500023Z" fill={props.color}/>
        </svg>
    );
};

export default TikTokLogo;